<template>
  <div class="funnel-form">
    <div class="funnel-form-section">
      <b-row>
        <b-col xs="12" sm="12" md="5">
          <InputText
              title="Nome"
              field="name"
              :formName="formName"
              :required="true"
              :maxLength="40"
              :markFormDirty="false"
              v-model="funnel.name"
          />
        </b-col>
        <b-col xs="12" sm="12" md="7">
          <InputText
              title="Descrição"
              field="description"
              :formName="formName"
              :maxLength="40"
              :markFormDirty="false"
              v-model="funnel.description"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <CheckboxSimple title="Exibir os valores das locações" v-model="funnel.showValue"/>
          <Alert type="info" class="funnel-form-alert">
            Necessário que o usuário tenha a regra <b>Locação</b>!
          </Alert>
        </b-col>
      </b-row>
    </div>

    <div class="funnel-form-divider"></div>

    <div class="funnel-form-section">
      <span class="funnel-form-section-title">Permissão</span>
      <CheckboxSimple title="Compartilhado com todos" v-model="funnel.shared"/>
      <div v-if="!funnel.shared" class="funnel-form-users">
        <b-row>
          <b-col xs="12" sm="12" md="6">
            <Select
                title="Usuário(s) com regra Planner"
                :showNewRegister="false"
                field="user"
                url="/api/v1/adm/user/select-all-by-rule-name"
                :propsParams="{ any: 'Planner' }"
                v-model="selectUser"
            />
          </b-col>
          <b-col xs="12" sm="12" md="4">
            <div class="funnel-form-btn-add">
              <Button
                  _key="btnAddUser"
                  type="primary"
                  :disabled="!selectUser.id"
                  classIcon="fa-solid fa-plus"
                  size="small"
                  :clicked="addUser"
              />
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
            <InputTag
                title="Permitidos"
                :initialValue="funnel.allowedUsers"
                v-model="funnel.allowedUsers"
            />
          </b-col>
        </b-row>
      </div>
    </div>

    <div class="funnel-form-divider"></div>

    <div class="funnel-form-footer">
      <Button
          _key="saveFunnel"
          type="success"
          title="Salvar"
          :disabled="!isFormValid(formName)"
          classIcon="fas fa-save"
          size="medium"
          :clicked="save"
      />
    </div>
  </div>
</template>

<script>
import Alert from "@/ui/layout/Alert";

import Button from "@/ui/forms/Button";
import CheckboxSimple from "@/ui/forms/CheckboxSimple.vue";
import InputTag from "@/ui/forms/InputTag";
import InputText from "@/ui/forms/InputText";
import Select from "@/ui/forms/Select";

import Funnel from "../../models/Funnel";
import FunnelService from "../../services/funnel.service";

import {mapGetters, mapMutations, mapState} from "vuex";

export default {
  name: "FunnelForm",
  components: {Alert, InputText, InputTag, Select, CheckboxSimple, Button},
  data() {
    return {
      formName: "funnelForm",
      funnel: new Funnel(),
      selectUser: {},
    };
  },
  computed: {
    ...mapState("user", ["userLogged"]),
    ...mapGetters("validation", ["isFormValid"]),
    ...mapGetters("generic", ["event"]),
  },
  methods: {
    ...mapMutations("generic", ["addEvent", "removeLoading", "hideModal"]),
    ...mapMutations("validation", ["resetValidation"]),
    async save() {
      this.funnel.userId = this.userLogged.user.id;
      try {
        if (this.funnel.id) {
          await FunnelService.update(this.funnel);
          this.addEvent({name: "funnelUpdated"});
        } else {
          await FunnelService.create(this.funnel);
          this.addEvent({name: "funnelCreated"});
        }
        this.hideModal();
      } finally {
        this.removeLoading(["saveFunnel"]);
      }
    },
    addUser() {
      if (!this.funnel.allowedUsers.includes(this.selectUser.content)) {
        this.funnel.allowedUsers.push(this.selectUser.content);
        this.selectUser = {};
      }
      this.removeLoading(["btnAddUser"]);
    },
    populateForEdit(data) {
      this.funnel = new Funnel().update(data);
    },
    resetForm() {
      this.resetValidation(this.formName);
      this.funnel = new Funnel();
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name === "funnelCreate") this.resetForm();
        if (event.name === "funnelUpdate") this.populateForEdit(event.data);
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.funnel-form-alert {
  margin-top: 10px;
}

.funnel-form-section {
  padding: 16px 0;
}

.funnel-form-section-title {
  display: block;
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--text-secondary);
  margin-bottom: 14px;
}

.funnel-form-divider {
  border-top: 1px solid var(--border-subtle);
}

.funnel-form-users {
  margin-top: 12px;
}

.funnel-form-btn-add {
  margin-top: 38px;
}

.funnel-form-footer {
  padding: 16px 0 4px;
  display: flex;
  justify-content: flex-end;
}
</style>
